import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", as: Tag = "h1" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-2 -mb-2">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.2 + i * 0.14 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Chapter({ number, eyebrow, title, dark = false, className = "" }) {
  return (
    <Reveal className={`mb-10 sm:mb-14 ${className}`}>
      <div className="flex items-center gap-4 sm:gap-6">
        <span
          className={`font-mono text-sm sm:text-base ${dark ? "text-sand" : "text-teal"}`}
          data-testid={`chapter-number-${number}`}
        >
          ({number})
        </span>
        <span className={`h-px flex-1 ${dark ? "bg-cream/20" : "bg-line"}`} aria-hidden="true" />
        <p className={`eyebrow ${dark ? "!text-sand/80" : ""}`}>{eyebrow}</p>
      </div>
      {title && (
        <h2
          className={`mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-snug max-w-3xl ${
            dark ? "text-cream" : "text-charcoal"
          }`}
        >
          {title}
        </h2>
      )}
    </Reveal>
  );
}
